import { useMediaQuery } from '@material-ui/core'
import { ExpandMore, Sort } from '@material-ui/icons'
import * as React from 'react'
import styled from 'styled-components'
import { animated, useSpring, config } from 'react-spring'
import { CollectorSelectedFilter } from '../TrendingCollectors'

const StyledTableHeader = styled.thead`
  position: relative;
  background: none;
  color: #aaa;

  th:first-child {
    padding-left: 15px;
    padding-right: 0;
  }

  th:last-child {
    padding-left: 0px;
    padding-right: 15px;
  }

  th {
    text-align: left;
    font-size: 14px;
    font-weight: 700;

    @media (max-width: 43em) {
      font-size: 12px;
    }
  }
`

const Filter = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 50px;
  white-space: nowrap;
  gap: 5px;
  cursor: pointer;
  color: ${(props) => (props.selected ? 'white' : '#aaa')};

  :hover {
    color: white;
  }
`

const DropdownFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  color: white;
`

const Menu = styled(animated.div)<{ visible: boolean }>`
  position: absolute;
  z-index: 100;
  /* top: calc(100% + 10px); */
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-width: 1px;
  border-color: #333;
  border-style: solid;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 15px 25px rgba(255, 255, 255, 0.052);
  pointer-events: ${(props) => (props.visible ? 'all' : 'none')};

  right: 15px;

  :focus,
  *:focus {
    outline: none;
  }
`

const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
`

const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: calc(100% - 20px);
  padding: 15px 10px;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;

  :hover {
    background: #232323;
  }
`

const MenuItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const MenuItemTitle = styled.div<{ color: string }>`
  font-weight: 700;
  color: ${(props) => props.color};
  font-size: 14px;
  text-align: right;
  width: 100%;

  @media (max-width: 43em) {
    font-size: 12px;
  }
`

interface Props {
  selected: CollectorSelectedFilter
  setSelected: (filter: CollectorSelectedFilter) => void
}

const CollectorHeader = ({ selected, setSelected }: Props): JSX.Element => {
  const isTablet = useMediaQuery('(max-width: 62em)')
  const [visible, setVisible] = React.useState(false)
  const [opened, setOpened] = React.useState(false)

  const menuOpenState = useSpring({
    opacity: visible ? 1 : 0,
    config: config.gentle,
    onRest: () => {
      setOpened(visible)
    },
  })

  const toggleHide = (): void => {
    if (opened) {
      setVisible(false)
      const element = document.getElementById('filter-menu')
      element?.blur()
    } else {
      setVisible(true)
    }
  }

  if (isTablet) {
    return (
      <StyledTableHeader id="filter-menu" tabIndex={0} onBlur={() => setVisible(false)}>
        <tr>
          <th>RANK</th>
          <th>
            <DropdownFilter onClick={toggleHide}>
              {selected === CollectorSelectedFilter.COLLECTED ? 'COLLECTED' : 'SPENT'}
              <ExpandMore />
            </DropdownFilter>
            <Menu visible={visible} style={menuOpenState}>
              <PopoverWrapper>
                <MenuItem onClick={() => setSelected(CollectorSelectedFilter.SPENT)}>
                  <MenuItemLeft>
                    <MenuItemTitle color="white">TOTAL SPENT</MenuItemTitle>
                  </MenuItemLeft>
                </MenuItem>
                <MenuItem onClick={() => setSelected(CollectorSelectedFilter.COLLECTED)}>
                  <MenuItemLeft>
                    <MenuItemTitle color="white">COLLECTED</MenuItemTitle>
                  </MenuItemLeft>
                </MenuItem>
              </PopoverWrapper>
            </Menu>
          </th>
        </tr>
      </StyledTableHeader>
    )
  }

  return (
    <StyledTableHeader>
      <tr>
        <th>RANK</th>
        <th>
          <Filter
            selected={selected === CollectorSelectedFilter.SPENT}
            onClick={() => setSelected(CollectorSelectedFilter.SPENT)}
          >
            {`TOTAL SPENT`}
            {selected === CollectorSelectedFilter.SPENT && <Sort />}
          </Filter>
        </th>
        <th>
          <Filter
            selected={selected === CollectorSelectedFilter.COLLECTED}
            onClick={() => setSelected(CollectorSelectedFilter.COLLECTED)}
          >
            {`COLLECTED`}
            {selected === CollectorSelectedFilter.COLLECTED && <Sort />}
          </Filter>
        </th>
      </tr>
    </StyledTableHeader>
  )
}

export default CollectorHeader
